import { createContext, createSignal, useContext, onCleanup } from 'solid-js';

// Create a context for the event bus
export const EventBusContext = createContext();

// Provider component to wrap the application with the event bus context
export const EventBusProvider = (props) => {
  const [lastEvent, setLastEvent] = createSignal(null);

  // Function to trigger an event and propagate it to the parent window
  const triggerEvent = (event) => {
    console.log('Event triggered', event);
    setLastEvent(event);
    window.parent.postMessage(event, '*');
  };

  const value = { triggerEvent, lastEvent };

  return (
    <EventBusContext.Provider value={value}>
      {props.children}
    </EventBusContext.Provider>
  );
};

// Hook to consume the event bus within components
export const useEventBus = () => {
  const eventBus = useContext(EventBusContext);
  if (!eventBus) {
    throw new Error('useEventBus must be used within an EventBusProvider');
  }
  return eventBus;
};
